import { useCallback, useEffect, useState } from 'react';
import Layer from '../assets/images/icon-layer-0.svg';
import cn from 'classnames';
import { JGAMap } from 'libs/Map';
import { Box } from '@mui/system';
import LayerGroup from 'ol/layer/Group';
import { LayerProp } from '@metadata';

const MapLayerSetting = ({ jgaMap, trigger, ai }: { jgaMap: JGAMap; trigger?: boolean; ai?: boolean }) => {
  const [hide1, setHide1] = useState(false);
  const [flat, setFlat] = useState<number>(0);
  const [checklist, setCheckList] = useState([]);

  const [layerList, setLayerList] = useState([]);

  useEffect(() => {
    if (!jgaMap) return;
    setup(jgaMap, ai);
  }, [jgaMap, trigger]);

  // useEffect(() => {
  //   if (!jgaMap) return;
  //   if (trigger) changeHandler(false, 'farmMap');
  // }, [trigger]);

  const setup = (jgaMap: JGAMap, aiLayer?: boolean) => {
    setLayerList([]);
    const layers = jgaMap.getLayers();

    const arr: any = [];
    layers.forEach((layer) => {
      // console.log(layer);
      const property = layer.getProperties();

      // console.log('-- > ', property);
      if (!property.showCheckBox) return;
      if (property.defaultCheckValue) {
        setCheckList((prev) => [...prev, property]);
      }
      if (layer instanceof LayerGroup) {
        const childLayer = layer.getLayers().getArray();
        // console.log(childLayer);

        const childs = childLayer.map((i) => i.getProperties());

        // const childItem = childs.map((i) => i.defaultCheckValue && i.tilename);
        const obj = {
          tilename: property.tilename,
          alias: property.alias,
          child: childs,
          childLegend: property.childLegend,
        };
        arr.push(obj);

        setCheckList((prev) => [...prev, ...childs.flat()]);
        setLayerList((prev) => [...prev, { child: arr }]);
        return;
      }
      const obj = {
        tilename: property.tilename,
        alias: property.alias,
        childLegend: property.childLegend,
      };
      arr.push(obj);
    });
    if (aiLayer) {
      arr.unshift({
        tilename: 'sample',
        alias: 'AI 분석결과',
        defaultCheckValue: true,
      });

      setCheckList((prev) => [...prev, { tilename: 'sample', alias: 'AI 분석결과', defaultCheckValue: true }]);
    }

    setLayerList(arr);
  };

  const changeHandler = (checked: boolean, tilename: any) => {
    //   jgaMap.setMapType(tilename, checked);
      // console.log(checked, tilename);
      const layer = jgaMap.getJgaLayer(tilename);
      if(layer.getProperties() && layer.getProperties().dommnNm && layer.getProperties().dommnNm === 'sea'){
        jgaMap.setClusterSource(tilename, checked, checklist);
    }else{
        jgaMap.setMapType(tilename, checked);
    }

    if (checked) {
      setCheckList((prev) => [...prev, layer.getProperties()]);
    } else {
      // 체크 해제
      setCheckList((prev) => prev.filter((el) => el.tilename !== tilename));
    }
  };

  //레이어 전체선택
  const handleAllCheck = useCallback(
    (checked: boolean, groupname: string) => {
      if (groupname === 'aiFeatureGroup') {
        jgaMap.setMapType('aiPolyFeatureGroup', checked);
      }
      jgaMap.setMapType(groupname, checked);

      if (checked) {
        layerList.map((i) => {
          if (i.tilename === groupname) {
            const child = i.child;
            child.map((childLayer: any) => {
              setCheckList((prev) => [...prev, childLayer]);
              if(childLayer.dommnNm && childLayer.dommnNm === 'sea'){
                jgaMap.setClusterGroup(checked, 'aiFeatureGroup');
              }else{
                jgaMap.setMapType(childLayer.tilename, checked);
              }
            });
          }
        });
      } else {
        layerList.map((i) => {
          if (i.tilename === groupname) {
            const child = i.child;
            child.map((childLayer: any) => {
                if(childLayer.dommnNm && childLayer.dommnNm === 'sea'){
                    jgaMap.setClusterGroup(checked, 'aiFeatureGroup');
                }else{
                    jgaMap.setMapType(childLayer.tilename, checked);
                }
                setCheckList((prev) => prev.filter((el) => el.tilename !== childLayer.tilename));
            });
          }
        });
      }
    },
    [checklist, layerList],
  );

  return (
    <div className="mapLayerLine01">
      {/* <!-- 지도 레이어 설정창, hide : 레이어창을 닫았을 경우 추가 --> */}
      <div className={hide1 ? 'mapLayer hide' : 'mapLayer'}>
        {/* <!-- mapLayerTitArea : 레이어창 제목 영역 --> */}
        <Box className="mapLayerTitArea">
          <div className="mapLayerTit">
            <img
              src={Layer}
              alt="지도 레이어 설정"
            />
            <span>지도 레이어 설정</span>
          </div>
          <button
            type="button"
            className="mapLayerTitBtn"
            onClick={() => setHide1((prev) => !prev)}
          >
            <span>레이어창 버튼</span>
          </button>
        </Box>
        {/* <!-- mapLayerConArea : 레이어창 내용 영역 --> */}
        <div className="mapLayerConArea">
          <ul className="mlcList">
            {layerList.map((item) => {
              const value = checklist.find((i) => i.tilename === item.tilename);
                
              return (
                <li key={item.tilename}>
                  {!item.child ? (
                    <div className="cCheckbox cCheckboxColor">
                      <input
                        type="checkbox"
                        id={item.tilename}
                        onChange={(e) => changeHandler(e.currentTarget.checked, item.tilename)}
                        defaultChecked={value ? value.defaultCheckValue : false}
                      />
                      <label htmlFor={item.tilename}>
                        <Svg color={value ? value.checkColor : ''} />
                        {item.alias}
                      </label>
                    </div>
                  ) : (
                    <div className="cCheckbox cCheckboxColor">
                      <input
                        type="checkbox"
                        id={item.tilename}
                        onChange={(e) => handleAllCheck(e.currentTarget.checked, item.tilename)}
                        defaultChecked={checklist.some((i) => i.tilename === item.tilename)}
                      />
                      <label htmlFor={item.tilename}>
                        <Svg color={value ? value.checkColor : ''} />
                        {item.alias}
                      </label>
                    </div>
                  )}
                  
                  {/* 세부레이어 리스트 */}
                  {item.child ? (
                    <ul className="mlcMax4">
                      {item.child.map((childItem: LayerProp) => {
                        if (!childItem.showCheckBox) return;
                        return (
                          <li key={childItem.tilename}>
                            <div className="cCheckbox cCheckboxColor">
                              <input
                                type="checkbox"
                                id={childItem.tilename}
                                onChange={(e) => changeHandler(e.currentTarget.checked, childItem.tilename)}
                                // defaultChecked={checklist.includes(childItem.tilename)}
                                // defaultChecked={checklist.some((i) => i.tilename === childItem.tilename)}
                                checked={checklist.some((i) => i.tilename === childItem.tilename)}
                              />
                              <label htmlFor={childItem.tilename}>
                                <Svg color={childItem.checkColor} />
                                {childItem.alias}
                              </label>
                            </div>
                          </li>
                        );
                      })}
                    </ul>
                  ) : null}

                  {/* jeju_gis 레이어 범례 */}
                  {item.childLegend ? (
                    <div data-dojo-attach-point="containerNode" style={{height: 'auto', fontSize: "0.753rem", display: value? '':'none'}}> 
                        {item.childLegend.map((legendItem: any) => {
                            if (!legendItem) return;
                            return (
                            <div className="agsjsTOCNode" id="TOCNode_JEJU_NSDI_3_legend0" data-widgetid="dijit__Templated_5" style={{marginTop: "2px"}}  key={legendItem.name}>
                                <div data-dojo-attach-point="rowNode" data-dojo-attach-event="onclick:_onClick" style={{paddingLeft: "26px"}}>
                                    <span data-dojo-attach-point="contentNode" className="agsjsTOCContent">
                                        <span data-dojo-attach-point="checkContainerNode"></span>
                                        <img 
                                            src={legendItem.imgSrc} 
                                            alt="" 
                                            data-dojo-attach-point="iconNode" 
                                            className="agsjsTOCIcon"
                                            style={{width:"10%"}} 
                                        />
                                        <span data-dojo-attach-point="labelNode" className="agsjsTOCLegendLabel" style={{paddingLeft: "5px"}}>{legendItem.name} </span>
                                    </span>
                                </div>
                            </div>
                            );
                        })}
                    </div>
                  ) : null}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
};

const Svg = ({ color = '004CBD' }: { color?: string }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <rect
        x="0.5"
        y="0.5"
        width="17"
        height="17"
        rx="2.5"
        fill={`#${color}`}
        stroke={`#${color}`}
      />
      <path
        d="M4 8L8 12L15 5"
        stroke="white"
        strokeWidth="2"
      />
    </svg>
  );
};

export default MapLayerSetting;
